module.exports = __webpack_public_path__ + "static/media/cloud.fed0f7b7.svg";